import { Controller } from "stimulus"

export default class extends Controller {
  static targets = [ "results", "form", "count", "totalArr", "frame" ]

  search() {
    clearTimeout(this.timeout)
    this.timeout = setTimeout(() => {
      if (this.hasFrameTarget) {
        this.loadResults(this.formTarget.action, new FormData(this.formTarget))
      } else {
        Rails.fire(this.formTarget, 'submit')
      }
    }, 200)
  }

  handleResults(event) {
    const [data, status, xhr] = event.detail
    if (this.hasFrameTarget) {
      this.frameTarget.innerHTML = xhr.response
    } else {
      this.resultsTarget.innerHTML = xhr.response
      this.recalcSummary()
    }
  }

  paginate(event) {
    if (!this.hasFrameTarget) return

    event.preventDefault()
    this.loadResults(event.currentTarget.dataset.searchUrl || event.currentTarget.href)
  }

  loadResults(url, formData = null) {
    const requestUrl = new URL(url, window.location.origin)

    if (formData) {
      formData.forEach((value, key) => {
        if (value === "") {
          requestUrl.searchParams.delete(key)
        } else {
          requestUrl.searchParams.set(key, value)
        }
      })
      requestUrl.searchParams.delete("page")
    }

    fetch(requestUrl.toString(), {
      headers: {
        "X-Requested-With": "XMLHttpRequest"
      },
      credentials: "same-origin"
    })
      .then((response) => response.text())
      .then((html) => {
        this.frameTarget.innerHTML = html
      })
  }

  // Summary totals are computed from the rows currently in the tbody, so
  // search/filter results stay in sync with the count (and ARR, where shown)
  // above. Pluralisation is taken from data-count-noun on the count target so
  // we can reuse this controller across customers ("customer") and prospects
  // ("prospect"). Customer rows additionally carry data-customer-arr; pages
  // without an ARR target skip the totalArr update.
  recalcSummary() {
    if (!this.hasCountTarget) return

    const noun = this.countTarget.dataset.countNoun || "result"
    const rows = this.resultsTarget.querySelectorAll("tr")
    const count = rows.length
    this.countTarget.textContent = `${count} ${count === 1 ? noun : noun + "s"}`

    if (this.hasTotalArrTarget) {
      let total = 0
      this.resultsTarget.querySelectorAll("tr[data-row-arr]").forEach((r) => {
        total += parseInt(r.dataset.rowArr, 10) || 0
      })
      this.totalArrTarget.textContent = total.toLocaleString("nl-NL")
    }
  }
}
